/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import BrandLogo from '../Partials/BrandLogo';
import SecureCheckout from '../Partials/SecureCheckout';
import ModalWrapper from '../../../../Common/ModalWrapper/ModalWrapper';
import BreadcrumbMobile from '../Partials/BreadcrumbMobile/BreadcrumbMobile';
import CheckoutHeaderPLA from '../../../../../../../components/GraphqlComponents/GraphqlHeader/CheckoutHeaderPLA';
import CheckoutMetaHeaderPLA from '../../../../../../../components/GraphqlComponents/GraphqlHeader/CheckoutMetaHeaderPLA';

// These are backup in case the logo has not been added in ContentStack.
const logos = {
    PLA: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt55247e0014fdfe9f/5f3ec458eb93e224977c1ab8/plants.png',
    CAN: 'https://images.contentstack.io/v3/assets/blt1253a5c1b168c76d/blt21d302c72abb41cd/5fa147c11a81c1644e99894c/canada-logo.png',
    '08F': 'https://images.contentstack.io/v3/assets/bltff8fca2c07fbcc09/blt7cadaed6919db76f/5f71a681968bb93b9e851898/0800flowers_logo_purple.png',
    '18F': 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blteb80eb70ce7579b2/5d1536b504e065d077c95a66/fw_logo_flowers_light@2x.png',
    '18B': 'https://cdn2.1800baskets.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/18b-logo-v2.svg',
    CCO: 'https://cdn2.cheryls.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/cco-logo-v2.svg',
    HD: 'https://cdn2.harryanddavid.com/wcsstore/RAPIDStorefrontAssetStore/images/ab/hd-logo-v2.svg',
    FBQ: 'https://images.contentstack.io/v3/assets/blte4aebfe2fb7fcc9d/bltc4f00aef9141b525/5f2aae04327a6201d7eb9468/fruitbouquets-logo.png',
};

const CheckoutMobileHeader = ({
    classes, onClick, currentTab,
    isPlaceOrder, brand, withLink,
    modalContent, isOpen,
    onCloseModal, btnClose,
    isAddOnWrapUp,
    dataDictionary,
    pathname,
}) => (
    <Grid
        container
        title="Secure Checkout"
        className={classes.root}
    >
        <Grid item xs={12} className={classes.mobileHeaderBlock}>
            {
                brand.code === 'PLA'
                    ? ''
                    : (
                        <div className={classes.secureCheckout}>
                            <SecureCheckout dataDictionary={dataDictionary} />
                        </div>
                    )
            }

            <div className={`${classes.brandLogo} ${brand.code}`}>
                <Button
                    id="btn-logo-brand"
                    data-test="btn-logo-brand"
                    data-testid="btn-logo-brand"
                    name="logoBrandButton"
                    className={classes.logoBrandBtn}
                    aria-label="18F"
                    onClick={onClick}
                >
                    <BrandLogo withLink={withLink} brand={brand.code} brandLogos={logos} />
                </Button>
                {
                    brand.code === 'PLA' ? <CheckoutHeaderPLA brand={brand} /> : ''
                }
            </div>
        </Grid>
        {
            brand.code === 'PLA' && pathname.indexOf('/cart/') === -1 ? <CheckoutMetaHeaderPLA icons={false} loginText="Sign In/Create Account" /> : ''
        }
        <Grid item xs={12} className={classes.navProgress}>
            {!isAddOnWrapUp && currentTab &&  <BreadcrumbMobile active={currentTab} isPlaceOrder={isPlaceOrder} />}
        </Grid>
        <ModalWrapper
            modalTitle={dataDictionary?.['LEAVE CHECKOUT'] || 'LEAVE CHECKOUT'}
            modalContent={modalContent}
            isOpen={isOpen}
            onCloseModal={onCloseModal}
            btnClose={btnClose}
        />
    </Grid>
);

CheckoutMobileHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    modalContent: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    btnClose: PropTypes.bool.isRequired,
    isAddOnWrapUp: PropTypes.bool.isRequired,
    isPlaceOrder: PropTypes.bool.isRequired,
    withLink: PropTypes.bool.isRequired,
    brand: PropTypes.string.isRequired,
    currentTab: PropTypes.string,
    dataDictionary: PropTypes.object,
    pathname: PropTypes.string,
};
CheckoutMobileHeader.defaultProps = {
    pathname: '',
    currentTab: null,
    dataDictionary: {},
};

export default (CheckoutMobileHeader);
